var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferToPlayerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm2.293-12.22L13.073 11a.75.75 0 001.06 1.06l2.324-2.323a1 1 0 000-1.414L14.134 6a.75.75 0 00-1.06 1.06l1.219 1.22h-6.44a.75.75 0 100 1.5h6.44zm-4.422 4.5l1.22-1.22A.75.75 0 0010.03 12l-2.324 2.323a1 1 0 000 1.414l2.323 2.324A.75.75 0 1011.09 17l-1.219-1.22h6.44a.75.75 0 000-1.5H9.87z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.476 3.63a8.5 8.5 0 10-2.952 16.74 8.5 8.5 0 002.952-16.74zm-3.64-1.393a10 10 0 114.328 19.526A10 10 0 019.836 2.237z",
    fill: "currentColor"
  })));
}
SvgTransferToPlayerFilled.displayName = 'TransferToPlayerFilled';
export default SvgTransferToPlayerFilled;